import { isDesktop } from "react-device-detect";
import { useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./router/Routes";
import RotatePage from "./components/common/RotatePage";
import { CheckForPwaInstall } from "./utils/installModalPwa/CheckForPwaInstall";
import CustomInstallModal from "./components/common/CustomInstallModal";
import Loading from "./components/common/Loading";
import { ToastContainer, toast } from "react-toastify";
import { subNotification } from "./services/api/wigoServices";
import { getTokenFirebase, onMessageListener } from "./firebase";
import md5 from "md5";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

const App = () => {
	const authToken = localStorage.getItem("token");

	const [isTokenFound, setTokenFound] = useState<any>(false);
	getTokenFirebase(setTokenFound);
	useEffect(() => {
		if (localStorage.getItem("fcm-token")) {
			return;
		}
		if (isTokenFound && authToken) {
			subscribeToNotifications(isTokenFound);
		}
	}, [isTokenFound]);

	const subscribeToNotifications = async (token: any) => {
		const res = await subNotification(token);
		if (res) {
			localStorage.setItem("fcm-token", token);
			console.log(res);
		}
	};

	const getFcmAPK = () => {
		//@ts-ignore
		if (window?.ReactNativeWebView) {
			const obj = { code: "AUTH_TOKEN_FOUND" };
			const stringObj = JSON.stringify(obj);
			//@ts-ignore
			window?.ReactNativeWebView?.postMessage(stringObj);
		}
	};

	useEffect(() => {
		if (authToken) {
			getFcmAPK();
		}
	}, [authToken]);

	onMessageListener()
		.then((payload) => {
			toast.info(
				`${payload.notification.title} :
      ${payload.notification.body}`,
				{
					position: "top-right",
					closeOnClick: true,
					closeButton: false,
					style: {
						backgroundColor: "#fff",
						borderRadius: 10,
						width: "90%",
					},
					bodyStyle: {
						direction: "rtl",
						textAlign: "justify",
						lineHeight: 2,
					},
				}
			);
		})
		.catch((err) => console.log("failed: ", err));

	const [loaded, setLoaded] = useState<boolean>(false);
	let portrait = window.matchMedia("(orientation: portrait)");
	const isLandscape = isDesktop ? false : !portrait.matches;
	const [rotated, setRotated] = useState(isLandscape);
	const handleRotate = (e: MediaQueryListEvent) => {
		if (isDesktop) {
			return;
		}
		setRotated(!e.matches);
	};
	const handleMessages = (event: any) => {
		if (event.data) {
			const data = event.data;

			switch (data.code) {
				case "APK":
					// alert("app opened from apk");
					localStorage.setItem("isFromAPK", "true");
					break;

				case "FCM":
					// alert(`app received fcm token: ${data.token}`);
					console.log(data.token);

					const result: any = subNotification(data.token);
					if (result?.status === 200) {
						const hashedValue = md5(data.token);
						localStorage.setItem("token-fir", hashedValue);
						localStorage.setItem("fcm-token", "true");
					}
					break;

				case "BIOMETRICS":
					// alert(`app received biometricsStatus: ${data.status}`);
					localStorage.setItem(
						"biometricsStatus",
						data.status ? "true" : "false"
					);
					break;

				case "NOTIFICATION_STATUS":
					// alert(data.code + " | " + data.status);
					localStorage.setItem(
						"APKnotificationPermission",
						data.status ? "true" : "false"
					);
					break;
				default:
					break;
			}
		}
	};
	useEffect(() => {
		if (localStorage.getItem("fcm-token")) {
			return;
		}
		var userAgent = window.navigator.userAgent.toLowerCase(),
			ios = /iphone|ipod|ipad/.test(userAgent);

		if (ios) {
			//ios
			window.addEventListener("message", handleMessages);
		} else {
			//not iOS
			document.addEventListener("message", handleMessages);
		}
		return () => {
			var userAgent = window.navigator.userAgent.toLowerCase(),
				ios = /iphone|ipod|ipad/.test(userAgent);

			if (ios) {
				window.removeEventListener("message", handleMessages);
			} else {
				document.removeEventListener("message", handleMessages);
			}
		};
	}, []);

	useLayoutEffect(() => {
		CheckForPwaInstall();
		// document.addEventListener("visibilitychange", () => {
		//   localStorage.removeItem("touchToken");
		// });

		const touchLogin = localStorage.getItem("touchLogin");

		if (touchLogin) {
			if (new Date().getTime() - new Date(touchLogin).getTime() >= 10000) {
				localStorage.setItem("shouldTouch", "true");
			} else {
				const now = new Date();
				localStorage.setItem("touchLogin", now.toISOString());
			}
		}
		portrait.addEventListener("change", handleRotate);
	}, []);

	return (
		<>
			{rotated ? <RotatePage /> : null}
			<CustomInstallModal />
			{!loaded ? (
				<div className="loadingMainPageContainer">
					<Loading />
				</div>
			) : null}
			<div className="containerApp" onLoad={() => setLoaded(true)}>
				<div className="containerRoute">
					<BrowserRouter>
						<Router />
						<ToastContainer />
					</BrowserRouter>
				</div>
			</div>
		</>
	);
};

export default App;
